/**
 * Time units and their corresponding seconds (from largest to smallest unit)
 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/RelativeTimeFormat/RelativeTimeFormat
 *
 */
const TIME_UNITS = [
  ["year", 31536000],
  ["month", 2592000],
  //["week", 604800],
  ["day", 86400],
  ["hour", 3600]
  //   ["minute", 60],
  //   ["second", 1]
];

/**
 * Convert a date to a relative time string, such as
 * "a minute ago", "in 2 hours", "yesterday", "3 months ago", etc.
 * using Intl.RelativeTimeFormat.
 *
 * @param {Date | number} date Date or timestamp to compare(in milliseconds since epoch)
 * @param {string} lang Language for formatting (default: browser language)
 * @returns Formatted relative time string
 */
export function getRelativeTimeString(
  date,
  lang
  //granularity: "auto" | "full" = "auto"
) {
  if (!date) throw new Error("A valid date must be provided.");
  const { value, unit } = getRelativeTime(date);
  const rtf = new Intl.RelativeTimeFormat(lang, { numeric: "auto" });

  return rtf.format(value, unit);
}

/**
 * Get the relative time for a given date
 * @param {Date | number} date
 * @returns {Object}
 */
export function getRelativeTime(date) {
  const { absoluteSeconds, deltaSeconds } = getSeconds(date);
  const [unit, seconds] = getTimeUnit(absoluteSeconds);

  // Use precise division to avoid rounding errors
  const absoluteValue = Math.floor(absoluteSeconds / seconds);
  const value = Math.sign(deltaSeconds) * absoluteValue;

  return { value, unit, absoluteValue };
}

/**
 * Get the time unit for a given value
 * @param {number} value
 * @returns {Array}
 */
function getTimeUnit(value) {
  return (
    TIME_UNITS.find(([, seconds]) => value >= seconds) ??
    TIME_UNITS[TIME_UNITS.length - 1]
  );
}

/**
 * Get the seconds for a given date
 * @param {Date | number} date
 * @returns {Object}
 */
function getSeconds(date) {
  const timeMs = typeof date === "number" ? date : date.getTime();

  const deltaSeconds = Math.round((timeMs - Date.now()) / 1000);
  const absoluteSeconds = Math.abs(deltaSeconds);

  return { deltaSeconds, absoluteSeconds };
}
